import { useContextSelector } from 'use-context-selector';

import { FlowTreeContext, FlowTreeContextType } from '../Tree';

const useTreeContext = <T>(selector: (state: FlowTreeContextType) => T) =>
  useContextSelector(FlowTreeContext, selector);

export default useTreeContext;
